import {
  CREATEDENTALLABRECORDALLOY,
  GETDENTALLABRECORDALLOY,
  UPDATEDENTALLABRECORDALLOY,
  DELETEDENTALLABRECORDALLOY,
  CREATEDENTALLABRECORDUNIT,
  GETDENTALLABRECORDUNIT,
  UPDATEDENTALLABRECORDUNIT,
  DELETEDENTALLABRECORDUNIT,
  CREATEDENTALLABRECORDSHADE,
  GETDENTALLABRECORDSHADE,
  UPDATEDENTALLABRECORDSHADE,
  DELETEDENTALLABRECORDSHADE,
  CREATEDENTALLABRECORDSTATUS,
  GETDENTALLABRECORDSTATUS,
  UPDATEDENTALLABRECORDSTATUS,
  DELETEDENTALLABRECORDSTATUS,
  CREATEDENTALLABRECORDLABNAME,
  GETDENTALLABRECORDLABNAME,
  UPDATEDENTALLABRECORDLABNAME,
  DELETEDENTALLABRECORDLABNAME,
  CREATEDENTALLABRECORDBILL,
  GETDENTALLABRECORDBILL,
  UPDATEDENTALLABRECORDBILL,
  DELETEDENTALLABRECORDBILL,
  CREATEDENTALLABRECORDTRANSACTION,
  GETDENTALLABRECORDTRANSACTION,
  UPDATEDENTALLABRECORDTRANSACTION,
  DELETEDENTALLABRECORDTRANSACTION,
  CREATEDENTALLABRECORDTEST,
  GETDENTALLABRECORDTEST,
  UPDATEDENTALLABRECORDTEST,
  DELETEDENTALLABRECORDTEST,
} from "../actions/types";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case CREATEDENTALLABRECORDALLOY:
      return {
        ...state,
        DentalLabRecordAlloySaveStatus: action.payload.success,
      };
    case GETDENTALLABRECORDALLOY:
      return {
        ...state,
        DentalLabRecordAlloyList: action.payload.data,
      };
    case UPDATEDENTALLABRECORDALLOY:
      return {
        ...state,
        DentalLabRecordAlloyUpdateStatus: action.payload.success,
      };

    case DELETEDENTALLABRECORDALLOY:
      return {
        ...state,
        DentalLabRecordAlloyDeleteStatus: action.payload.success,
      };

    case CREATEDENTALLABRECORDUNIT:
      return {
        ...state,
        DentalLabRecordUnitSaveStatus: action.payload.success,
      };
    case GETDENTALLABRECORDUNIT:
      return {
        ...state,
        DentalLabRecordUnitList: action.payload.data,
      };
    case UPDATEDENTALLABRECORDUNIT:
      return {
        ...state,
        DentalLabRecordUnitUpdateStatus: action.payload.success,
      };

    case DELETEDENTALLABRECORDUNIT:
      return {
        ...state,
        DentalLabRecordUnitDeleteStatus: action.payload.success,
      };

    case CREATEDENTALLABRECORDSHADE:
      return {
        ...state,
        DentalLabRecordShadeSave: action.payload.success,
      };
    case GETDENTALLABRECORDSHADE:
      return {
        ...state,
        DentalLabRecordShadeList: action.payload.data,
      };
    case UPDATEDENTALLABRECORDSHADE:
      return {
        ...state,
        DentalLabRecordShadeUpdate: action.payload.success,
      };

    case DELETEDENTALLABRECORDSHADE:
      return {
        ...state,
        DentalLabRecordShadeDelete: action.payload.success,
      };

    case CREATEDENTALLABRECORDSTATUS:
      return {
        ...state,
        DentalLabRecordStatusSave: action.payload.success,
      };
    case GETDENTALLABRECORDSTATUS:
      return {
        ...state,
        DentalLabRecordStatusList: action.payload.data,
      };
    case UPDATEDENTALLABRECORDSTATUS:
      return {
        ...state,
        DentalLabRecordStatusUpdate: action.payload.success,
      };

    case DELETEDENTALLABRECORDSTATUS:
      return {
        ...state,
        DentalLabRecordStatusDelete: action.payload.success,
      };

    case CREATEDENTALLABRECORDLABNAME:
      return {
        ...state,
        DentalLabRecordLabNameSave: action.payload.success,
      };
    case GETDENTALLABRECORDLABNAME:
      return {
        ...state,
        DentalLabRecordLabNameList: action.payload.data,
      };
    case UPDATEDENTALLABRECORDLABNAME:
      return {
        ...state,
        DentalLabRecordLabNameUpdate: action.payload.success,
      };

    case DELETEDENTALLABRECORDLABNAME:
      return {
        ...state,
        DentalLabRecordLabNameDelete: action.payload.success,
      };

    case CREATEDENTALLABRECORDBILL:
      return {
        ...state,
        DentalLabRecordBillSaveStatus: action.payload.success,
      };
    case GETDENTALLABRECORDBILL:
      return {
        ...state,
        DentalLabRecordBillList: action.payload.data,
      };
    case UPDATEDENTALLABRECORDBILL:
      return {
        ...state,
        DentalLabRecordBillUpdateStatus: action.payload.success,
      };

    case DELETEDENTALLABRECORDBILL:
      return {
        ...state,
        DentalLabRecordBillDeleteStatus: action.payload.success,
      };

    case CREATEDENTALLABRECORDTRANSACTION:
      return {
        ...state,
        DentalLabRecordTransactionSaveStatus: action.payload.success,
      };
    case GETDENTALLABRECORDTRANSACTION:
      return {
        ...state,
        DentalLabRecordTransactionList: action.payload.data,
      };
    case UPDATEDENTALLABRECORDTRANSACTION:
      return {
        ...state,
        DentalLabRecordTransactionUpdateStatus: action.payload.success,
      };

    case DELETEDENTALLABRECORDTRANSACTION:
      return {
        ...state,
        DentalLabRecordTransactionDeleteStatus: action.payload.success,
      };

    case CREATEDENTALLABRECORDTEST:
      return {
        ...state,
        DentalLabRecordTestSaveStatus: action.payload.success,
      };
    case GETDENTALLABRECORDTEST:
      return {
        ...state,
        DentalLabRecordTestList: action.payload.data,
      };
    case UPDATEDENTALLABRECORDTEST:
      return {
        ...state,
        DentalLabRecordTestUpdateStatus: action.payload.success,
      };

    case DELETEDENTALLABRECORDTEST:
      return {
        ...state,
        DentalLabRecordTestDeleteStatus: action.payload.success,
      };

    default:
      return state;
  }
}
